// extracted by mini-css-extract-plugin
export var dataCell = "_qf-2";
export var dataRow = "_qf-0";
export var headerRow = "_qf-1";